// node-modules
import React, { Fragment, useCallback } from 'react';
import { observer } from 'mobx-react';
// store
import { useStore } from 'modules/Stores';
// components
import ChartSyncProgressModal from '../ChartSyncProgressModal';

const ChartSyncProgressModalContainer = () => {
  const {
    toggleModal,
    modalsConfig: { syncProgress },
  } = useStore('AppStore');
  const {
    currentPhase,
    syncingInProgress,
  } = useStore('ChartSyncStore');

  const handleClose = useCallback(() => {
    if (syncingInProgress) {
      return;
    }
    toggleModal('syncProgress');
  }, [syncingInProgress, toggleModal]);

  return syncProgress ? (
    <ChartSyncProgressModal
      onClose={handleClose}
      currentPhase={currentPhase}
    />
  ) : (
    <Fragment />
  );
};

export default observer(ChartSyncProgressModalContainer);
